import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connectModal } from 'redux-modal';
import Script from './Script';

class Popup extends Component {

  render() {
    const { show, website, handleHide } = this.props;
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>Website - {website.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Script website={website} />
        </Modal.Body>
      </Modal>
    );
  }
}

const PixelPopModal = connectModal({ 
  name: 'PixelPopModal' 
});

export default PixelPopModal(Popup);
